const BioCard = ({ bio }) => (
    <div className="rounded-2xl bg-white border border-secondary-200 shadow-soft p-5">
        <div className="text-secondary-700 whitespace-pre-line">{bio}</div>
    </div>
);

export default BioCard;
